import React, { useContext, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import {
      EnquiryBox,
      EnquiryFooter,
      EnquirySlider
} from '../../styles/frontend/dealers';
import { Form } from 'react-bootstrap';

import axios from 'axios';
import { SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { toast } from 'react-hot-toast';
import {
      DealerIcon,
      PrivacyIcon,
      TermsCondition
} from '../../components/icons';
import SupportTicketIcon from '../../components/icons/SupportTicketIcon';
import { Link } from 'react-router-dom';

import $ from 'jquery';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import FormInput from '../../components/common/form/FormInput';
import FormTextarea from '../../components/common/form/FormTextarea';
import FormButton from '../../components/common/form/FormButton';
import MetaContext from '../../stores/MetaContext';

const DealerEnquiry = () => {
      const [firstName, setFirstName] = useState('');
      const [lastName, setLastName] = useState('');
      const [email, setEmail] = useState('');
      const [message, setMessage] = useState('');
      const [companyName, setCompanyName] = useState('');
      const [address, setAddress] = useState('');
      const [vatNo, setVatNo] = useState('');
      const [phoneNumber, setPhoneNumber] = useState('');
      const [loading, setLoading] = useState(false);

      const metaCtx = useContext(MetaContext);
      metaCtx.handleSlug('dealer-enquiry');

      const handleSubmit = async (event) => {
            event.preventDefault();

            const data = {
                  name: firstName + ' ' + lastName,
                  email: email,
                  message: message,
                  company_name: companyName,
                  address: address,
                  vat_no: vatNo,
                  phone: phoneNumber
            };
            setLoading(true);
            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dealer_enquiry`,
                        data,
                        {
                              headers: {
                                    apikey: process.env.REACT_APP_Api_Key
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              $('form').trigger('reset');
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.name) {
                                    toast.error(response.data.message.name);
                              }
                              if (response.data.message.email) {
                                    toast.error(response.data.message.email);
                              }
                              if (response.data.message.phone) {
                                    toast.error(response.data.message.phone);
                              }
                              if (response.data.message.company_name) {
                                    toast.error(
                                          response.data.message.company_name
                                    );
                              }
                              if (response.data.message.address) {
                                    toast.error(response.data.message.address);
                              }
                              if (response.data.message.message) {
                                    toast.error(response.data.message.message);
                              }
                              if (response.data.message.vat_no) {
                                    toast.error(response.data.message.vat_no);
                              }
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });

            setLoading(false);
      };

      const options = {
            margin: 30,
            responsiveClass: true,
            nav: false,
            dots: false,
            lazyLoad: true,
            autoplay: false,
            navText: ['Prev', 'Next'],
            smartSpeed: 1000,
            responsive: {
                  0: {
                        items: 1
                  },
                  400: {
                        items: 1
                  },
                  600: {
                        items: 2
                  },
                  700: {
                        items: 3
                  },
                  1000: {
                        items: 4
                  }
            }
      };

      return (
            <>
                  <Breadcrumb title="Dealer Enquiry" />
                  <Container>
                        <Row className="justify-content-center">
                              <Col lg={10}>
                                    <EnquiryBox>
                                          <Form onSubmit={handleSubmit}>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="First Name"
                                                            required={true}
                                                            handleChange={
                                                                  setFirstName
                                                            }
                                                      />

                                                      <FormInput
                                                            title="Last Name"
                                                            required={true}
                                                            handleChange={
                                                                  setLastName
                                                            }
                                                      />

                                                      <FormInput
                                                            title="Email Address"
                                                            type="email"
                                                            required={true}
                                                            handleChange={
                                                                  setEmail
                                                            }
                                                      />

                                                      <FormInput
                                                            title="Phone No."
                                                            required={true}
                                                            handleChange={
                                                                  setPhoneNumber
                                                            }
                                                      />

                                                      <FormInput
                                                            title="Company Name"
                                                            required={true}
                                                            handleChange={
                                                                  setCompanyName
                                                            }
                                                      />

                                                      <FormInput
                                                            title="VAT No."
                                                            handleChange={
                                                                  setVatNo
                                                            }
                                                            required={true}
                                                      />

                                                      <FormInput
                                                            required={true}
                                                            title="Address"
                                                            classes={12}
                                                            handleChange={
                                                                  setAddress
                                                            }
                                                      />

                                                      <FormTextarea
                                                            title="Your Message"
                                                            required={true}
                                                            classes={12}
                                                            handleChange={
                                                                  setMessage
                                                            }
                                                      />

                                                      <FormButton
                                                            loading={loading}
                                                      />
                                                </Row>
                                          </Form>
                                    </EnquiryBox>
                              </Col>
                        </Row>
                  </Container>

                  <EnquiryFooter>
                        <Container>
                              <EnquirySlider {...options} className="owl-theme">
                                    <SwiperSlide>
                                          <Link to="/customer-enquiry">
                                                <div>
                                                      <SupportTicketIcon />
                                                </div>
                                                <div>Customer Enquiry</div>
                                          </Link>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                          <Link to="/dealer-enquiry">
                                                <div>
                                                      <DealerIcon />
                                                </div>
                                                <div>Dealer Enquiry</div>
                                          </Link>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                          <Link to="/terms-and-conditions">
                                                <div>
                                                      <TermsCondition />
                                                </div>
                                                <div>Terms & Conditions</div>
                                          </Link>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                          <Link to="/support-ticket">
                                                <div>
                                                      <SupportTicketIcon />
                                                </div>
                                                <div>Support Ticket</div>
                                          </Link>
                                    </SwiperSlide>
                              </EnquirySlider>
                        </Container>
                  </EnquiryFooter>
            </>
      );
};

export default DealerEnquiry;
